import clsx from 'clsx';

import { Content } from '@/lib';
import styles from './Delimiter.module.scss';
import { Row } from '../../Row';

export function Delimiter({ fluid }: Content.WithFluid<Content.Delimiter>) {
  return (
    <Row className={clsx(fluid && styles.fluid)}>
      <div className={styles.delimiter} />
    </Row>
  );
}
